import { baseApi } from "api/BaseApi";

import { PolicyLetter, PolicyLettersPayload } from "./policies.types";

const POLICIES_BASE_QUERY = "publish/policies";

const publicPoliciesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    listPublicPolicies: build.query<PolicyLetter[], PolicyLettersPayload>({
      query: ({ archived }) => ({
        url: `${POLICIES_BASE_QUERY}/get_public_policies/`,
        params: { archived },
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useListPublicPoliciesQuery } = publicPoliciesApi;
